module.exports = __webpack_public_path__ + "static/media/logout.e9065f55.svg";